import { BaseColor, toast } from "@soft-db/ui";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

export type SnackbarProps = {
	show: boolean;
	message: string;
	color: string;
	buttonColor: BaseColor;
	position: "bottom" | "top";
};

export const SET_SNACKBAR = "SET_SNACKBAR";

export const useSnackbarStore = defineStore("snackbar-store", () => {
	const snackbar = ref<SnackbarProps>({
		show: false,
		message: "",
		color: "",
		buttonColor: "default",
		position: "bottom",
	});

	const { t } = useI18n();

	function openOnSaved() {
		toast.success(t("snackbar.changesSaved"), {
			position: "top-right",
			closeButton: true,
		});
	}

	function openOnMessage(message: string) {
		toast(message, {
			closeButton: true,
			position: "top-right",
		});
	}

	function openOnError(message?: string | Error) {
		let text: string;
		if (message == null || message instanceof Error) {
			text = t("snackbar.internalServerError");
		} else {
			text = message;
		}

		toast.error(text, {
			important: true,
			position: "bottom-center",
		});
	}

	return {
		snackbar,
		openOnSaved,
		openOnMessage,
		openOnError,
	};
});
